// import { otherRouter, appRouter } from '@/router/router';
// import AppUtil from './appUtil';
// import Util from '@/libs/util';

const table = {
    state: {
        // 表格columns
        tableCol: {}, 
        // 表格class数组
        tableMove: []
    },
    mutations: {
        updateTableCol(state, tableCol) {
            state.tableCol = tableCol;
        },
        updateTableMove(state, tableMove) {
            state.tableMove = tableMove;
        },
    }
};

export default table;


// WEBPACK FOOTER //
// ./src/store/modules/table.js